import React, { useCallback } from 'react';
import { Container } from 'react-bootstrap';

import PoDetailProvider from 'providers/PoDetailProvider';

import PurchaseOrderDetailInfo from 'components/purchase-order/purchase-order/PurchaseOrderDetails/PurchaseOrderDetailInfo';
import PurchaseOrderLines from 'components/purchase-order/purchase-order/PurchaseOrderDetails/PurchaseOrderLines';

const PurchaseOrderDetail = () => {
  const handlePoLineUpdate = useCallback(() => {
    window.dispatchEvent(new CustomEvent('po-line-updated'));
  }, []);

  return (
    <PoDetailProvider>
      <Container fluid className="p-0 d-flex flex-column gap-4">
        <PurchaseOrderDetailInfo listenToUpdates={true} />

        <PurchaseOrderLines onPoLineUpdate={handlePoLineUpdate} />
      </Container>
    </PoDetailProvider>
  );
};

export default PurchaseOrderDetail;
